import dayJS from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { CountUp } from 'countup.js';
import { initFaqSection } from "@/modules/section-faq";
import { initFooterSection } from "@/modules/section-footer";
import { initUploader as initNewUploader } from "@/modules/uploader";
import { clickTracker } from "@/scripts/helpers/clickTracker";
import ready from "@/scripts/helpers/dom/ready";
import video from "@/modules/lazyframe";
import Cookies from 'js-cookie';
import cookiePopup from "@/modules/popup-cookie";
import WOW from "wowjs";

const initWowLibrary = () => {
	window.wow = new WOW.WOW({
		offset: 100,
		live: false
	});
	window.wow.resetAnimation = function() {};
	window.wow.init();
};

const initFormsActionsCounters = () => {
  const counterInitBlock = document.getElementById('action-counters-current-date');

  if (!counterInitBlock) return;

  dayJS.extend(advancedFormat);

  const initCurrentDate = () => {
    const dayFormat = 'MMM Do, YYYY';

    counterInitBlock.textContent = `${dayJS().format(dayFormat)}`;
  };
  initCurrentDate();

  const dailyMax = {
    0: { edits: 35534, sends: 3198, signs: 4264 },
    1: { edits: 72780, sends: 6550, signs: 8734 },
    2: { edits: 75381, sends: 6784, signs: 9046 },
    3: { edits: 73503, sends: 6615, signs: 8820 },
    4: { edits: 70816, sends: 6373, signs: 8498 },
    5: { edits: 59903, sends: 5391, signs: 7188 },
    6: { edits: 31872, sends: 2868, signs: 3825 }
  };

  const getValueForNow = maxValue => {
    // w1 - длительность утреннего подъема
    // w2 - длительность вечернего спада
    // t1 - время утреннего подъема
    // t2 - время вечернего спада

    const consts = {
      0: { w1: 150, w2: 240, t1: 420, t2: 1320 },
      1: { w1: 150, w2: 250, t1: 420, t2: 1080 },
      2: { w1: 150, w2: 250, t1: 420, t2: 1080 },
      3: { w1: 150, w2: 250, t1: 420, t2: 1080 },
      4: { w1: 150, w2: 250, t1: 420, t2: 1080 },
      5: { w1: 150, w2: 180, t1: 420, t2: 960 },
      6: { w1: 150, w2: 250, t1: 420, t2: 1060 }
    };
    const BOSTON_HOURS_OFFSET = -4;
    const PERCENT_GROWTH_PER_YEAR = 20;
    const today = new Date();
    const todayDay = today.getDay();
    const fullYear = today.getFullYear();
    const fullHours = today.getHours();
    const fullMinutes = today.getMinutes();
    const fullSeconds = today.getSeconds();
    const hoursZeroOffset = today.getTimezoneOffset() / 60;
    const { w1, w2, t1, t2 } = consts[todayDay];

    const hoursZoneCorrection = hours =>
      hours > 0 ? (hours < 24 ? hours : hours - 24) : 24 - hours;
    const yearlyGrowingCorrection = year =>
      ((year - 2019) * PERCENT_GROWTH_PER_YEAR) / 100 + 1;
    const correctedHours = hoursZoneCorrection(
      fullHours + hoursZeroOffset + BOSTON_HOURS_OFFSET
    );
    const totalSecondsFromMidnight =
      correctedHours * 3600 + fullMinutes * 60 + fullSeconds;

    // const getValueByDate = x => 2.7**(-((x-1)**2)/0.2);
    const getValueByDate = ({ curMinute, maxValue, w1, w2, t1, t2 }) => {
      const minRate = Math.round(maxValue / (4 * 1440));
      const baseRate = (maxValue - minRate * 1440) / 600;
      return (
        minRate * curMinute +
        (baseRate / 2) *
        (w1 * Math.log(Math.abs(Math.cosh((curMinute - t1) / w1))) -
          w1 * Math.log(Math.abs(Math.cosh(-t1 / w1))) -
          w2 * Math.log(Math.abs(Math.cosh((curMinute - t2) / w2))) +
          w2 * Math.log(Math.abs(Math.cosh(-t2 / w2))))
      );
    };

    const currentValue = Math.floor(
      getValueByDate({
        curMinute: totalSecondsFromMidnight / 60,
        maxValue,
        w1,
        w2,
        t1,
        t2
      })
    );
    return currentValue;
  };

  const todayDay = new Date().getDay();
  const todayData = dailyMax[todayDay];
  const randomUpdate = successPercentage =>
    !!(Math.random() < successPercentage / 100);

  // initial insert
  const countUpEdits = new CountUp('counter-edit', getValueForNow(todayData.edits), { duration: 1.5 });
  countUpEdits.start();
  const countUpSigns = new CountUp('counter-sign', getValueForNow(todayData.signs), { duration: 1.15 });
  countUpSigns.start();
  const countUpSends = new CountUp('counter-send', getValueForNow(todayData.sends), { duration: 0.75 });
  countUpSends.start();

  // random update
  setInterval(() => {
    if (randomUpdate(30)) {
      countUpEdits.update(getValueForNow(todayData.edits));
    }
  }, 1000);

  setInterval(() => {
    if (randomUpdate(30)) {
      countUpSigns.update(getValueForNow(todayData.signs));
    }
  }, 1000);

  setInterval(() => {
    if (randomUpdate(30)) {
      countUpSends.update(getValueForNow(todayData.sends));
    }
  }, 1000);
};

window.sendAbEvent = (event, route = '/api/ab-tower/track-event') => {
  var ajax = new XMLHttpRequest();
  ajax.open('POST', route, true);
  ajax.setRequestHeader('Content-Type', 'application/json');
  ajax.setRequestHeader('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]').content);
  ajax.send(JSON.stringify({'event': event}));
};

window.initUploader = payload => {


  if (window.UPLOADER === undefined) return;



  const hasUploaderNode = !!document.getElementById('uploader-app-node');
  let uploader = null;

  if (!hasUploaderNode) {
    uploader = window.UPLOADER({
      ...payload

    });
  } else {
    uploader = window.UPLOADER({
      ...payload,
      dashboardSelector: '#uploader-app-node',
    });
  }
};

const initRatingVote = () => {
  const triggers = document.querySelectorAll('.page-section--feature-how-to .rating__star');
  const votesElement = document.querySelectorAll('.page-section--feature-how-to .js-rating-votes-value')[0];
  const tokenTag = document.querySelectorAll('[name=csrf-token]')[0];

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function() {
      const parent = trigger.parentNode;
      const value = Array.from(triggers).indexOf(trigger) + 1;

      const featureIdElement = document.getElementsByName('data-featureid')[0];
      const featureId = featureIdElement.getAttribute('value');
      const token = tokenTag.getAttribute('content');

      const alreadyVoted = !!Cookies.get(`feature-rating-${featureId}`);

      if (alreadyVoted) return;

      parent.classList.add('has-voted');

      triggers.forEach(t => {
        t.classList.remove('is-filled');
        t.classList.remove('is-half-filled');
      });

      for (let i = 0; i < Number(value); i++) {
        triggers[i].classList.add('is-filled');
      }


      fetch('/api/feature/update-rating', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': token,
        },
        body: JSON.stringify({
          id: featureId,
          stars: value,
        }),
        cache: 'default'
      })
        .then(response => response.json())
        .then(() => {
          Cookies.set(`feature-rating-${featureId}`, value);

          if (!!votesElement) {
            votesElement.textContent = (Number(votesElement.textContent) + 1);
          }
        });
    });
  });
};

window.clickTracker = clickTracker;

initFormsActionsCounters();

if (window.dropArea) {
  initNewUploader();
};

ready( () => {
  window.clickTracker();
  initFaqSection();
  initFooterSection();
  video();
  initRatingVote();
  initWowLibrary();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});
